export enum INTENTION_TYPE {
  INTENTION = 'intention',
  BIRTHDAY = 'birthday',
  ARRIVAL = 'arrival',
}
